<template>
  <ux-form
    ref="form"
    :data="formData"
    width="400px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="addSms"
  >
    <ux-form-item :label="$t('HT.addSms.name')" prop="name">
      <ux-input
        v-model="formData.name"
        :maxlength="10"
        :disabled="formData.id ? true : false"
        :placeholder="$t('HT.addSms.placeholder1')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addMsgTemp.status')" prop="status">
      <ux-select
        v-model="formData.status"
        :options="$opt.SmsStatus"
        :placeholder="$t('HT.addSms.placeholder2')"
      ></ux-select>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          name: '', // 短信名称
          status: '' // 审核状态
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addSms()
    };
  }
};
</script>
